'use client';

import { useChromePathname } from '@/shared/components/providers/chrome-pathname';

export function useHiddenComponentByPage(pageNames: string[]) {
  // Chrome-safe pathname: null at prerender/first render → not hidden, which
  // matches the neutral shell; pre-paint CSS guards cover route-specific hides.
  const pathname = useChromePathname();
  if (pathname === null) return false;
  return pageNames.some((name) => pathname.startsWith(name));
}
